import _ from 'lodash-es';

export default function (variant = {}) {
  const parameter = _.find(variant?.parameters || [], item => Number(item?.parameter?.id ?? item?.parameterId) === 1);
  const parameterValueName = _.trim(
    variant?.primaryParameterValueName
    || parameter?.value?.name
    || parameter?.value?.value
    || _.first(parameter?.values)?.name
    || ''
  );
  const name = _.trim(localized(variant, 'name'));

  return _.filter([parameterValueName, name]).join(' - ');
}
